<footer class="main-footer">
    <div class="float-right d-none d-sm-block">
      <b>Version</b> 0.1
    </div>
    <strong>Copyright &copy; 2023 <a href="#">Al-Husnain Motors Ltd</a>.</strong> All rights reserved.
</footer>